import React from "react";
import {
  TextField,
  FormControl,
  Select,
  MenuItem,
  Switch,
  Typography,
  Box,
  Tooltip,
  Grid,
} from "@mui/material";
import PublicIcon from "@mui/icons-material/Public";
import LockIcon from "@mui/icons-material/Lock";
import LanguageSelector from "./LanguageSelector";
import { AIModelInfoTooltip } from "./AIModelInfoDialog";
import { AIModelSelect } from "./TestComponents2";
import QuestionMarkIcon from "@mui/icons-material/Help";

const AdditionalFlashFields = ({
  aiInstructions,
  setAiInstructions,
  numFlashcards,
  setNumFlashcards,
  category,
  setCategory,
  language,
  setLanguage,
  difficulty,
  setDifficulty,
  visibility,
  handleVisibilityChange,
  theme,
  selectedModel,
  setSelectedModel,
  user,
}) => {
  return (
    <Box>
      <Grid container spacing={3} sx={{ mt: 0 }}>
        {/* Number of Flashcards */}

        {/* AI Instructions - Full width */}
        <Grid item xs={12}>
          <Typography variant="formLabel">
            Kompletterande instruktioner
          </Typography>

          <TextField
            fullWidth
            sx={{ mt: 1 }}
            margin="normal"
            placeholder="T.ex. Ekvationen på framsidan, uträkningen på baksidan"
            value={aiInstructions}
            onChange={(e) => setAiInstructions(e.target.value)}
            inputProps={{ maxLength: 200 }}
          />
        </Grid>

        {/* Visibility - Full width */}
        <Grid item xs={12} sx={{ display: "none" }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              backgroundColor:
                theme.palette.mode === "dark" ? "#394653" : "#f5f5f5",
              borderRadius: "10px",
              padding: "12px",
              paddingTop: "5px",
              paddingBottom: "5px",

              mb: 4, // Added more bottom margin
            }}
          >
            <Box display="flex" alignItems="center">
              <Tooltip title="Ska samlingen vara tillgänglig för andra att använda?">
                <Typography variant="formLabel">Synlighet</Typography>
              </Tooltip>
              {visibility === "public" ? (
                <PublicIcon sx={{ marginLeft: 1, fontSize: "20px" }} />
              ) : (
                <LockIcon sx={{ marginLeft: 1, fontSize: "20px" }} />
              )}
            </Box>
            <Box display="flex" alignItems="center">
              <Typography variant="caption" sx={{ mr: 1 }}>
                {visibility === "public" ? "Publik" : "Privat"}
              </Typography>
              <Switch
                checked={visibility === "public"}
                onChange={handleVisibilityChange}
                name="visibility"
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AdditionalFlashFields;
